export default function transformGetOtTech(ot) {
  ot.dateSouhaitee = ot.dateSouhaitee ? new Date(ot.dateSouhaitee) : null;
  ot.datePlanification = ot.datePlanification ? new Date(ot.datePlanification) : null;
  ot.dateRealisation = ot.dateRealisation ? new Date(ot.dateRealisation) : null;
  ot.dateFacture = ot.dateFacture ? new Date(ot.dateFacture) : null;
  return ot;
}
